import { useTranslation } from 'react-i18next'

import { WidgetListPipeline } from '../../Widget'
import { useDocFlowMappingContext } from '../DocFlow.hooks'
import { isDocFlowSplittingType } from '../DocFlow.utils.mapping'

import { AdditionalButtons } from './AdditionalButtons'
import {
  getDocFlowMappingActiveFileType,
  renderWidget,
} from './DocFlowMappingWidgets.utils'

function DocFlowMappingWidgets(props) {
  const { t } = useTranslation()

  const { activeFile, activeWidget, processData, widgets } =
    useDocFlowMappingContext()

  const activeType = getDocFlowMappingActiveFileType(activeFile, t)

  const isSplitting = isDocFlowSplittingType(activeType?.value)

  return (
    <WidgetListPipeline
      {...props}
      {...(isSplitting ? null : { Actions: null })}
      activeType={activeType}
      activeWidget={activeWidget}
      isSkeleton={!processData}
      items={widgets}
      renderItem={renderWidget}
    >
      <AdditionalButtons isSplitting={isSplitting} />
    </WidgetListPipeline>
  )
}

export default DocFlowMappingWidgets
